module.exports = __webpack_public_path__ + "img/ic-tiktok-inc.0a833a2c.svg";